(function() {
  'use strict';

  const ContextManager = {
    STORAGE_KEY: 'site_context',
    CONTEXT_INFANTIL: 'infantil',
    CONTEXT_GERIATRICO: 'geriatrico',

    getLocal: function() {
      try {
        return localStorage.getItem(this.STORAGE_KEY);
      } catch {
        return null;
      }
    },


    setLocal: function(context) {
      try {
        localStorage.setItem(this.STORAGE_KEY, context);
      } catch {
        console.warn('Falha ao salvar contexto no localStorage');
      }
    },


setCartAttribute: async function(context) {
  try {
    let cart = await fetch('/cart.js', { cache: 'no-store' }).then(res => res.json());

    if (!cart || cart.item_count === 0) {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { _init: 'true' } }),
      });

      cart = await fetch('/cart.js', { cache: 'no-store' }).then(res => res.json());
    }

    const attributes = cart.attributes || {};
    attributes.context = context;

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes }),
    });

    console.info('Contexto salvo no carrinho:', context);
  } catch (e) {
    console.warn('Falha ao salvar contexto no carrinho', e);
  }
},
    detectFromTemplate: function() {
      const meta = document.querySelector('meta[name="shopify-template"]');
      const path = window.location.pathname;
      if ((meta && meta.content.includes('geriatrico')) || path.includes('geriatrico')) {
        return this.CONTEXT_GERIATRICO;
      }
      return this.CONTEXT_INFANTIL;
    },

    applyContext: function(context) {
      document.body.classList.remove('context-infantil', 'context-geriatrico');
      document.body.classList.add('context-' + context);
      document.body.dataset.context = context;
    },

    /**
     * Define o contexto globalmente (JS + Shopify)
     */
    setContext: function(context) {
      if (![this.CONTEXT_INFANTIL, this.CONTEXT_GERIATRICO].includes(context)) return;

      this.setLocal(context);
      this.setCartAttribute(context);
      this.applyContext(context);

      window.dispatchEvent(new CustomEvent('context:changed', { detail: context }));
    },

    /**
 * Inicializa o sistema
 */
init: async function() {
  let context = this.getLocal();

  if (!context) {
    try {
      const cart = await fetch('/cart.js', { cache: 'no-store' }).then(res => res.json());
      if (cart && cart.attributes && cart.attributes.context) {
        context = cart.attributes.context;
        this.setLocal(context);
      }
    } catch (err) {
      console.warn('Não foi possível buscar contexto do carrinho', err);
    }
  }

  if (!context) {
    context = this.detectFromTemplate();
    this.setLocal(context);
  }

  this.applyContext(context);

  window.ContextManager = this;
}
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => ContextManager.init());
  } else {
    ContextManager.init();
  }
})();